import { render, staticRenderFns } from "./TicketFullStatus.vue?vue&type=template&id=5232b5d0&scoped=true&"
import script from "./TicketFullStatus.vue?vue&type=script&lang=js&"
export * from "./TicketFullStatus.vue?vue&type=script&lang=js&"
import style0 from "./TicketFullStatus.vue?vue&type=style&index=0&id=5232b5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232b5d0",
  null
  
)

export default component.exports